import {
  CLEAR_DASHBOARD_STATES,
  SAVE_BRANDS,
  SAVE_CUSTOM_RECRUIT_CATEGORY,
  SAVE_DASHBOARD_FILTER,
  SAVE_FAVORITE_BRANDS,
  SAVE_FORMS,
  SAVE_HOUSEHOLD,
  SAVE_OCCASION,
  SAVE_PARTICIPANT_SEGMENT,
} from "../utils/constants";

const initialState = {
  brandsList: [],
  favoriteBrands: [],
  customRecruitCategories: [],
  formsList: [],
  houseHoldlist: {},
  occasionsListData: {
    question_id: "",
    options: "",
  },
  participantSegmentsList: [],
  hideFilter: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_BRANDS:
      return {
        ...state,
        brandsList: action.payload || [],
      };
    case SAVE_FAVORITE_BRANDS:
      return {
        ...state,
        favoriteBrands: action.payload || [],
      };
    case SAVE_CUSTOM_RECRUIT_CATEGORY:
      return {
        ...state,
        customRecruitCategories: action.payload || [],
      };
    case SAVE_FORMS:
      return {
        ...state,
        formsList: action.payload || [],
      };
    case SAVE_HOUSEHOLD:
      return {
        ...state,
        houseHoldlist: action.payload || {},
      };
    case SAVE_OCCASION:
      return {
        ...state,
        occasionsListData: action.payload || {
          question_id: "",
          options: "",
        },
      };
    case SAVE_PARTICIPANT_SEGMENT:
      return {
        ...state,
        participantSegmentsList: action.payload || {},
      };
    case SAVE_DASHBOARD_FILTER:
      return {
        ...state,
        hideFilter: action.payload,
      };
    case CLEAR_DASHBOARD_STATES:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
